import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9fe66446"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "element-loading-background": "rgba(0, 0, 0, 0.5)" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "合同信息")
], -1))
const _hoisted_3 = { style: {"float":"left"} }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "link" }
const _hoisted_6 = { style: {"padding":"0px 10px","height":"26px"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"80px"} }, "货物清单", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","width":"60px","font-size":"14px","text-align":"right","padding-right":"5px"} }, " 币制 ", -1))
const _hoisted_9 = { style: {"float":"left","width":"200px","margin-top":"-5px"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left","font-size":"14px","text-align":"left","padding-right":"5px"} }, " （注意：包装内型号无具体数量的信息，在产品列表中销售数量的相关统计中将被剔除） ", -1))
const _hoisted_11 = { style: {"float":"right","margin-top":"-5px"} }
const _hoisted_12 = ["title"]
const _hoisted_13 = ["title"]
const _hoisted_14 = ["onClick", "title"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "*", -1))
const _hoisted_16 = ["title"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "*", -1))
const _hoisted_18 = ["title"]
const _hoisted_19 = ["onClick", "title"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "*", -1))
const _hoisted_21 = ["title", "onClick"]
const _hoisted_22 = ["title"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 尺寸与数量 ", -1))
const _hoisted_25 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_26 = { style: {"width":"100% !important","overflow":"hidden","height":"46px"} }
const _hoisted_27 = { style: {"width":"100% !important","overflow":"hidden","height":"46px"} }
const _hoisted_28 = { style: {"width":"100% !important","overflow":"hidden","height":"46px"} }
const _hoisted_29 = { style: {"width":"100% !important","overflow":"hidden","height":"46px"} }
const _hoisted_30 = { style: {"width":"100% !important","overflow":"hidden","height":"46px"} }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "*", -1))
const _hoisted_32 = { style: {"width":"100% !important","overflow":"hidden","height":"46px"} }
const _hoisted_33 = { style: {"clear":"both","height":"25px"} }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 产品型号/数量/货值 ", -1))
const _hoisted_35 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_36 = { style: {"width":"100% !important","overflow":"hidden","height":"46px"} }
const _hoisted_37 = { style: {"width":"100% !important","overflow":"hidden","height":"46px"} }
const _hoisted_38 = { style: {"width":"100% !important","overflow":"hidden","height":"46px"} }
const _hoisted_39 = { style: {"width":"100% !important","overflow":"hidden","height":"46px"} }
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { style: {"width":"100% !important","overflow":"hidden","height":"46px"} }
const _hoisted_43 = { style: {"width":"100% !important","overflow":"hidden","height":"46px"} }
const _hoisted_44 = { style: {"width":"100% !important","overflow":"hidden","height":"46px"} }
const _hoisted_45 = { style: {"width":"100% !important","overflow":"hidden","height":"46px"} }
const _hoisted_46 = { style: {"clear":"both","height":"25px"} }
const _hoisted_47 = { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }
const _hoisted_48 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_49 = { style: {"clear":"both","height":"25px"} }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " ID ", -1))
const _hoisted_51 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_52 = { style: {"max-height":"620px","overflow-y":"auto"} }
const _hoisted_53 = { style: {"clear":"both","height":"25px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_miezz_upload = _resolveComponent("miezz-upload")!
  const _component_miezz_form = _resolveComponent("miezz-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_miezz_customs_package = _resolveComponent("miezz-customs-package")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_miezz_thumbnail = _resolveComponent("miezz-thumbnail")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createVNode(_component_el_card, null, {
        header: _withCtx(() => [
          _hoisted_2
        ]),
        default: _withCtx(() => [
          _createVNode(_component_miezz_form, {
            ref: "ruleForm",
            modelValue: _ctx.form,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form) = $event)),
            fix: true
          }, {
            "form-item": _withCtx(({ item }) => [
              (item.Prop == 'Code')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    prop: item.Prop,
                    label: item.Label
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_miezz_input, {
                        modelValue: _ctx.form.Data.Code,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.Data.Code) = $event)),
                        placeholder: '请填写',
                        onHandleBlur: _ctx.onTrimSpace
                      }, null, 8, ["modelValue", "onHandleBlur"])
                    ]),
                    _: 2
                  }, 1032, ["prop", "label"]))
                : _createCommentVNode("", true),
              (item.Prop == 'SigningTime')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 1,
                    prop: item.Prop,
                    label: item.Label
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        clearable: false,
                        modelValue: _ctx.form.Data.SigningTime,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.Data.SigningTime) = $event)),
                        style: {"width":"100% !important"},
                        type: "date",
                        "value-format": "YYYY/MM/DD",
                        placeholder: "请选择"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["prop", "label"]))
                : _createCommentVNode("", true),
              (item.Prop == 'Partner')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 2,
                    prop: item.Prop,
                    label: _ctx.type == '10' ? '供应商' : '采购商'
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.form.Data.Partner,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.Data.Partner) = $event)),
                        style: {"width":"100% !important"},
                        filterable: "",
                        "allow-create": "",
                        "default-first-option": "",
                        "reserve-keyword": false,
                        placeholder: "请选择"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.partners, (item, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.Label,
                              label: item.Label,
                              value: item.Label
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_3, _toDisplayString(item.Label), 1),
                                (item.Data.IsDelete==true)
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      style: {"float":"right","color":"var(--el-text-color-secondary)","font-size":"13px"},
                                      onClick: ($event: any) => (_ctx.onDeletePartner(item.Value,index))
                                    }, [
                                      _createVNode(_component_el_icon, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Delete)
                                        ]),
                                        _: 1
                                      })
                                    ], 8, _hoisted_4))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1032, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["prop", "label"]))
                : _createCommentVNode("", true),
              (item.Prop == 'Address')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 3,
                    prop: item.Prop,
                    label: item.Label
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_autocomplete, {
                        modelValue: _ctx.form.Data.Address,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.Data.Address) = $event)),
                        clearable: true,
                        "fetch-suggestions": _ctx.querySearchAddressAsync,
                        "popper-class": "my-autocomplete",
                        placeholder: "请填写关键词",
                        onSelect: _ctx.handleSelectAddress
                      }, {
                        default: _withCtx(({ item }) => [
                          _createElementVNode("span", _hoisted_5, _toDisplayString(item), 1)
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "fetch-suggestions", "onSelect"])
                    ]),
                    _: 2
                  }, 1032, ["prop", "label"]))
                : _createCommentVNode("", true),
              (item.Prop == 'Requirement')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 4,
                    prop: item.Prop,
                    label: item.Label
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.form.Data.Requirement,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.Data.Requirement) = $event)),
                        autosize: { minRows: 5, maxRows: 5 },
                        type: "textarea",
                        placeholder: "请填写"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["prop", "label"]))
                : _createCommentVNode("", true),
              (item.Prop == 'OrderWarehouseAnnexs')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 5,
                    prop: item.Prop,
                    label: item.Label
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_miezz_upload, {
                        modelValue: _ctx.form.Data.OrderWarehouseAnnexs,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.Data.OrderWarehouseAnnexs) = $event)),
                        path: "orderWarehouse/annex",
                        accept: "file/*",
                        prop: "Url",
                        maxSize: 10 * 1024 * 1024
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 2
                  }, 1032, ["prop", "label"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_card, { style: {"margin-top":"5px"} }, {
        header: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_miezz_select, {
                modelValue: _ctx.form.Data.CurrencySystemId,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.Data.CurrencySystemId) = $event)),
                options: _ctx.currencys,
                clearable: false,
                valueKey: "Value",
                labelKey: "Label",
                onHandleChange: _ctx.onChangeCurrencyId
              }, null, 8, ["modelValue", "options", "onHandleChange"])
            ]),
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_button, {
                onClick: _ctx.onAddPackage,
                type: "primary",
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_Plus)
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" 添加")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_miezz_form, {
            ref: "ruleFormPackage",
            modelValue: _ctx.form,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form) = $event)),
            fix: true
          }, {
            "form-item": _withCtx(({ item }) => [
              (item.Prop == 'CurrencySystemId')
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    "label-width": "0px"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { style: {"margin-top":"-15px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_table, {
                                data: _ctx.form.Data.Packages,
                                ref: "formPackageTable",
                                stripe: "",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_table_column, {
                                    prop: "Package",
                                    label: " 包装编号",
                                    width: "180px"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createVNode(_component_el_form_item, {
                                        "label-width": "0px",
                                        style: {"height":"45px"}
                                      }, {
                                        default: _withCtx(() => [
                                          (scope.row.Package == null || scope.row.Package == undefined)
                                            ? (_openBlock(), _createElementBlock("div", {
                                                key: 0,
                                                style: {"width":"100% !important","overflow":"hidden","word-break":"break-all","text-overflow":"ellipsis","white-space":"nowrap"},
                                                title: scope.row.Code
                                              }, _toDisplayString(_ctx.isString(scope.row.Code)), 9, _hoisted_12))
                                            : (_openBlock(), _createElementBlock("div", {
                                                key: 1,
                                                style: {"width":"100% !important","overflow":"hidden","word-break":"break-all","text-overflow":"ellipsis","white-space":"nowrap"},
                                                title: scope.row.Package.Code
                                              }, _toDisplayString(_ctx.isString(scope.row.Package.Code)), 9, _hoisted_13))
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "SizeQuantity",
                                    label: " 箱规cm*cm*cm与数量"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createElementVNode("div", {
                                        onClick: ($event: any) => (_ctx.onShape(scope.$index)),
                                        style: {"color":"#f38338","cursor":"pointer","width":"100% !important","overflow":"hidden","word-break":"break-all","text-overflow":"ellipsis","white-space":"nowrap"},
                                        title: scope.row.SizeQuantity
                                      }, _toDisplayString(_ctx.isString(scope.row.SizeQuantity)), 9, _hoisted_14)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "GrossWeight",
                                    label: "单件毛重/KGS",
                                    width: "150px"
                                  }, {
                                    header: _withCtx(() => [
                                      _hoisted_15,
                                      _createTextVNode(" 单件毛重/KGS ")
                                    ]),
                                    default: _withCtx((scope) => [
                                      (scope.row.IsGrossWeight == true)
                                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                                            key: 0,
                                            "label-width": "0px"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", {
                                                style: {"width":"100% !important","overflow":"hidden","word-break":"break-all"},
                                                title: scope.row.GrossWeight
                                              }, _toDisplayString(_ctx.isString(scope.row.GrossWeight)), 9, _hoisted_16)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : (_openBlock(), _createBlock(_component_el_form_item, {
                                            key: 1,
                                            "label-width": "0px",
                                            label: "",
                                            prop: `Packages[${scope.$index}].GrossWeight`,
                                            rules: _ctx.form.Rules.Packages_GrossWeight
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_miezz_input, {
                                                onHandleBlur: ($event: any) => (_ctx.onChangePackageGrossWeight(scope.$index)),
                                                modelValue: scope.row.GrossWeight,
                                                "onUpdate:modelValue": ($event: any) => ((scope.row.GrossWeight) = $event),
                                                style: {"width":"100% !important"}
                                              }, null, 8, ["onHandleBlur", "modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _: 2
                                          }, 1032, ["prop", "rules"]))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "Volume",
                                    label: "单件体积/CBM",
                                    width: "150px"
                                  }, {
                                    header: _withCtx(() => [
                                      _hoisted_17,
                                      _createTextVNode(" 单件体积/CBM ")
                                    ]),
                                    default: _withCtx((scope) => [
                                      (scope.row.IsVolume == true)
                                        ? (_openBlock(), _createBlock(_component_el_form_item, {
                                            key: 0,
                                            "label-width": "0px"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", {
                                                title: scope.row.Volume,
                                                style: {"width":"100% !important","overflow":"hidden","word-break":"break-all","text-overflow":"ellipsis","white-space":"nowrap"}
                                              }, _toDisplayString(_ctx.isString(scope.row.Volume)), 9, _hoisted_18)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        : (_openBlock(), _createBlock(_component_el_form_item, {
                                            key: 1,
                                            "label-width": "0px",
                                            label: "",
                                            prop: `Packages[${scope.$index}].Volume`,
                                            rules: _ctx.form.Rules.Packages_Volume
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_miezz_input, {
                                                onHandleBlur: ($event: any) => (_ctx.onChangePackageVolume(scope.$index)),
                                                modelValue: scope.row.Volume,
                                                "onUpdate:modelValue": ($event: any) => ((scope.row.Volume) = $event),
                                                style: {"width":"100% !important"}
                                              }, null, 8, ["onHandleBlur", "modelValue", "onUpdate:modelValue"])
                                            ]),
                                            _: 2
                                          }, 1032, ["prop", "rules"]))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "ProductName",
                                    label: "产品名称"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createElementVNode("div", {
                                        onClick: ($event: any) => (_ctx.onSpec(scope.$index)),
                                        style: {"color":"#f38338","cursor":"pointer","width":"100% !important","overflow":"hidden","word-break":"break-all","text-overflow":"ellipsis","white-space":"nowrap"},
                                        title: scope.row.ProductName
                                      }, _toDisplayString(_ctx.isString(scope.row.ProductName)), 9, _hoisted_19)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "Quantity",
                                    label: "包装数量",
                                    width: "150px"
                                  }, {
                                    header: _withCtx(() => [
                                      _hoisted_20,
                                      _createTextVNode(" 包装数量 ")
                                    ]),
                                    default: _withCtx((scope) => [
                                      _createVNode(_component_el_form_item, {
                                        "label-width": "0px",
                                        label: "",
                                        prop: `Packages[${scope.$index}].Quantity`,
                                        rules: _ctx.form.Rules.Packages_Quantity
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_miezz_input, {
                                            onHandleBlur: ($event: any) => (_ctx.onChangePackageQuantity(scope.$index)),
                                            modelValue: scope.row.Quantity,
                                            "onUpdate:modelValue": ($event: any) => ((scope.row.Quantity) = $event),
                                            style: {"width":"100% !important"}
                                          }, null, 8, ["onHandleBlur", "modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _: 2
                                      }, 1032, ["prop", "rules"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "ShipmentId",
                                    label: "Shipment ID",
                                    width: "180px"
                                  }, {
                                    default: _withCtx((scope) => [
                                      (scope.row.Quantity > 0)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            title: scope.row.ShipmentId,
                                            onClick: ($event: any) => (_ctx.onShipment(scope.$index)),
                                            style: {"color":"#f38338","cursor":"pointer","width":"100% !important","overflow":"hidden","word-break":"break-all","text-overflow":"ellipsis","white-space":"nowrap"}
                                          }, _toDisplayString(_ctx.isString(scope.row.ShipmentId)), 9, _hoisted_21))
                                        : (_openBlock(), _createElementBlock("div", {
                                            key: 1,
                                            title: scope.row.ShipmentId,
                                            style: {"width":"100% !important","overflow":"hidden","word-break":"break-all","text-overflow":"ellipsis","white-space":"nowrap"}
                                          }, _toDisplayString(_ctx.isString(scope.row.ShipmentId)), 9, _hoisted_22))
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "DeliveryQuantity",
                                    label: "已交货数量",
                                    width: "150px"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createVNode(_component_el_form_item, {
                                        "label-width": "0px",
                                        label: "",
                                        style: {"text-align":"left"}
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_miezz_input, {
                                            disabled: (scope.row.Quantity==null || scope.row.Quantity==undefined)?true:false,
                                            onHandleBlur: ($event: any) => (_ctx.onChangePackageDeliveryQuantity(scope.$index)),
                                            modelValue: scope.row.DeliveryQuantity,
                                            "onUpdate:modelValue": ($event: any) => ((scope.row.DeliveryQuantity) = $event),
                                            style: {"width":"100% !important"}
                                          }, null, 8, ["disabled", "onHandleBlur", "modelValue", "onUpdate:modelValue"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_table_column, {
                                    prop: "DeliveryQuantity",
                                    label: "操作",
                                    width: "60px"
                                  }, {
                                    default: _withCtx((scope) => [
                                      _createElementVNode("div", {
                                        onClick: ($event: any) => (_ctx.onDeletePackage(scope.$index)),
                                        style: {"color":"#cc3333","cursor":"pointer","width":"100% !important","overflow":"hidden","word-break":"break-all"}
                                      }, [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Delete)
                                          ]),
                                          _: 1
                                        })
                                      ], 8, _hoisted_23)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["data"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      })
    ])), [
      [
        _directive_loading,
        _ctx.isLoading,
        void 0,
        {
          fullscreen: true,
          lock: true
        }
      ]
    ]),
    _createVNode(_component_miezz_button_bar, {
      modelValue: _ctx.bottomButtons,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.bottomButtons) = $event)),
      onHandleClick: _ctx.handleClick
    }, null, 8, ["modelValue", "onHandleClick"]),
    _createVNode(_component_miezz_customs_package, {
      isSelectCompany: false,
      ref: "CustomsPackage",
      onOnSelectProductPackage: _ctx.onSelectProductPackage
    }, null, 8, ["onOnSelectProductPackage"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.shapeRuleForm.Data.visible,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.shapeRuleForm.Data.visible) = $event)),
      "show-close": false,
      top: "10px",
      style: {"width":"80%"},
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          ref: "ruleFormShape",
          modelValue: _ctx.shapeRuleForm,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.shapeRuleForm) = $event)),
          fix: true
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'Length')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  "label-width": "0px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table, {
                      data: _ctx.shapeRuleForm.Data.Items,
                      ref: "packageTable",
                      stripe: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          prop: "Length",
                          label: " L/Φ(长度/直径)(cm)"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_miezz_input, {
                                    modelValue: scope.row.Length,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.Length) = $event),
                                    style: {"width":"95% !important"},
                                    onHandleBlur: ($event: any) => (_ctx.onChangeLength(scope.$index))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "Width",
                          label: " W/Φ(宽度/直径)(cm)"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_27, [
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_miezz_input, {
                                    modelValue: scope.row.Width,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.Width) = $event),
                                    style: {"width":"95% !important"},
                                    onHandleBlur: ($event: any) => (_ctx.onChangeWidth(scope.$index))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "Height",
                          label: "H(高度)(cm)"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_28, [
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_miezz_input, {
                                    modelValue: scope.row.Height,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.Height) = $event),
                                    style: {"width":"95% !important"},
                                    onHandleBlur: ($event: any) => (_ctx.onChangeHeight(scope.$index))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "Volume",
                          label: "体积(CBM)"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_29, [
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_miezz_input, {
                                    disabled: (scope.row.Length != undefined && scope.row.Width != undefined && scope.row.Height != undefined)?true: false,
                                    modelValue: scope.row.Volume,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.Volume) = $event),
                                    style: {"width":"95% !important"},
                                    onHandleBlur: ($event: any) => (_ctx.onChangeVolume(scope.$index))
                                  }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onHandleBlur"])
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "GrossWeight",
                          label: "毛重(KGS)"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_30, [
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_miezz_input, {
                                    modelValue: scope.row.GrossWeight,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.GrossWeight) = $event),
                                    style: {"width":"95% !important"},
                                    onHandleBlur: ($event: any) => (_ctx.onChangeGrossWeight(scope.$index))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "Quantity",
                          label: "数量"
                        }, {
                          header: _withCtx(() => [
                            _hoisted_31,
                            _createTextVNode(" 数量 ")
                          ]),
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_32, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: "",
                                prop: `Items[${scope.$index}].Quantity`,
                                rules: _ctx.shapeRuleForm.Rules.Items_Quantity
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_miezz_input, {
                                    modelValue: scope.row.Quantity,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.Quantity) = $event),
                                    style: {"width":"95% !important"},
                                    onHandleBlur: ($event: any) => (_ctx.onChangeQuantity(scope.$index))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                                ]),
                                _: 2
                              }, 1032, ["prop", "rules"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_33, [
          _createVNode(_component_miezz_button_bar, {
            modelValue: _ctx.shapeBottomButtons,
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.shapeBottomButtons) = $event)),
            isBackground: true,
            onHandleClick: _ctx.handleClickShape
          }, null, 8, ["modelValue", "onHandleClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.specRuleForm.Data.visible,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.specRuleForm.Data.visible) = $event)),
      "show-close": false,
      top: "10px",
      style: {"width":"80%"},
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _hoisted_34,
        _createElementVNode("div", _hoisted_35, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_miezz_form, {
          ref: "ruleFormSpec",
          modelValue: _ctx.specRuleForm,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.specRuleForm) = $event)),
          fix: true
        }, {
          "form-item": _withCtx(({ item }) => [
            (item.Prop == 'NameZh')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  "label-width": "0px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table, {
                      data: _ctx.specRuleForm.Data.Items,
                      ref: "packageTable",
                      stripe: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          prop: "NameZh",
                          label: "产品中文名称"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_36, [
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_miezz_select, {
                                    modelValue: scope.row.NameZh,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.NameZh) = $event),
                                    options: scope.row.Zh,
                                    clearable: false,
                                    valueKey: "Name",
                                    labelKey: "Name"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "NameEn",
                          label: " 产品英文名称"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_37, [
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_miezz_select, {
                                    modelValue: scope.row.NameEn,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.NameEn) = $event),
                                    options: scope.row.En,
                                    clearable: false,
                                    valueKey: "Name",
                                    labelKey: "Name"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "Height",
                          label: "规格型号名称"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_38, [
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(scope.row.Spec.Name), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "SpecImages",
                          label: "图片"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_39, [
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  (scope.row.Spec.SpecImages !=null && scope.row.Spec.SpecImages !=undefined &&scope.row.Spec.SpecImages.length>0)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        onClick: ($event: any) => (_ctx.onImage(scope.row)),
                                        style: {"color":"#f38338","cursor":"pointer","width":"100% !important","overflow":"hidden","word-break":"break-all"}
                                      }, " 查看 ", 8, _hoisted_40))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                        _createVNode(_component_miezz_thumbnail, {
                                          type: 'image',
                                          icon: 'DocumentDelete'
                                        })
                                      ]))
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "Quantity",
                          label: "数量"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_42, [
                              (scope.row.ShapeCount == 1)
                                ? (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 0,
                                    "label-width": "0px",
                                    label: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_miezz_input, {
                                        modelValue: scope.row.Quantity,
                                        "onUpdate:modelValue": ($event: any) => ((scope.row.Quantity) = $event),
                                        style: {"width":"95% !important"},
                                        onHandleBlur: ($event: any) => (_ctx.onChangeSpecQuantity(scope.$index))
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : (_openBlock(), _createBlock(_component_el_form_item, {
                                    key: 1,
                                    "label-width": "0px",
                                    label: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(scope.row.Quantity), 1)
                                    ]),
                                    _: 2
                                  }, 1024))
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "ChargeUnithEn",
                          label: "单位"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_43, [
                              _createVNode(_component_el_form_item, { "label-width": "0px" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_miezz_input, {
                                    modelValue: scope.row.ChargeUnithEn,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.ChargeUnithEn) = $event),
                                    "fetch-suggestions": _ctx.getChargeUnitEns,
                                    valueKey: "NameEn"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "fetch-suggestions"])
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "UnitPrice",
                          label: '单价（' + _ctx.form.Data.CurrencySystemName + '）'
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_44, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_miezz_input, {
                                    modelValue: scope.row.UnitPrice,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.UnitPrice) = $event),
                                    style: {"width":"95% !important"},
                                    onHandleBlur: ($event: any) => (_ctx.onChangeSpecUnitPrice(scope.$index))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"]),
                        _createVNode(_component_el_table_column, {
                          prop: "TotalPrice",
                          label: '总价（' + _ctx.form.Data.CurrencySystemName + '）'
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_45, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_miezz_input, {
                                    modelValue: scope.row.TotalPrice,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.TotalPrice) = $event),
                                    style: {"width":"95% !important"},
                                    onHandleBlur: ($event: any) => (_ctx.onChangeSpecTotalPrice(scope.$index))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onHandleBlur"])
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_46, [
          _createVNode(_component_miezz_button_bar, {
            modelValue: _ctx.specBottomButtons,
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.specBottomButtons) = $event)),
            isBackground: true,
            onHandleClick: _ctx.handleClickSpec
          }, null, 8, ["modelValue", "onHandleClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.imageRuleForm.visiable,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.imageRuleForm.visiable) = $event)),
      "show-close": false,
      style: {"width":"40%"},
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.imageRuleForm.row.Spec.Product.NameZh) + "/" + _toDisplayString(_ctx.imageRuleForm.row.Spec.Name), 1),
        _createElementVNode("div", _hoisted_48, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_carousel, {
            interval: 5000,
            arrow: "always",
            loop: false
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imageRuleForm.row.Images, (item) => {
                return (_openBlock(), _createBlock(_component_el_carousel_item, { key: item }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_image, {
                      style: {"width":"100%","height":"100%"},
                      src: item,
                      fit: _ctx.fit
                    }, null, 8, ["src", "fit"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_49, [
          _createVNode(_component_miezz_button_bar, {
            modelValue: _ctx.imageBottomButtons,
            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.imageBottomButtons) = $event)),
            isBackground: true,
            onHandleClick: _ctx.handleClickImage
          }, null, 8, ["modelValue", "onHandleClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.shipmentRuleForm.visiable,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.shipmentRuleForm.visiable) = $event)),
      top: "10px",
      "show-close": false,
      style: {"width":"680px"},
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "append-to-body": true
    }, {
      header: _withCtx(({ close }) => [
        _hoisted_50,
        _createElementVNode("div", _hoisted_51, [
          _createVNode(_component_el_icon, {
            style: {"cursor":"pointer"},
            onClick: close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CloseBold)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          ref: "ruleFormShipment",
          modelValue: _ctx.shipmentRuleForm,
          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.shipmentRuleForm) = $event)),
          fix: true
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shipmentRuleForm.rows, (p, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                (p.Type == 10)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "Shipment ID"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          style: {"width":"500px !important"},
                          modelValue: p.Value,
                          "onUpdate:modelValue": ($event: any) => ((p.Value) = $event),
                          onHandleBlur: _cache[18] || (_cache[18] = ($event: any) => (_ctx.onChangeShipment()))
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shipmentRuleForm.rows, (p, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                (p.Type == 11)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      label: "Reference ID"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          style: {"width":"500px !important"},
                          modelValue: p.Value,
                          "onUpdate:modelValue": ($event: any) => ((p.Value) = $event),
                          onHandleBlur: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onChangeShipment()))
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_52, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.shipmentRuleForm.rows, (p, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  (p.Type == 20)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: "FBA No."
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(index - 1) + "、", 1),
                          _createVNode(_component_miezz_input, {
                            style: {"width":"508px !important"},
                            modelValue: p.Value,
                            "onUpdate:modelValue": ($event: any) => ((p.Value) = $event),
                            onHandleBlur: _cache[20] || (_cache[20] = ($event: any) => (_ctx.onChangeShipment()))
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_53, [
          _createVNode(_component_miezz_button_bar, {
            modelValue: _ctx.shipmentBottomButtons,
            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.shipmentBottomButtons) = $event)),
            isBackground: true,
            onHandleClick: _ctx.handleClickShipment
          }, null, 8, ["modelValue", "onHandleClick"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}